/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import type { OrderStatus } from "./types";

const STYLE: Record<OrderStatus, { cls: string; icon: string }> = {
  draft: { cls: "badge-ghost", icon: "edit_note" },
  sent: { cls: "badge-info badge-outline", icon: "send" },
  partially_received: { cls: "badge-warning badge-outline", icon: "inventory_2" },
  received: { cls: "badge-success", icon: "check_circle" },
  cancelled: { cls: "badge-ghost opacity-60", icon: "block" },
};

export const OrderStatusBadge = defineComponent<{ status: OrderStatus }>({
  name: "OrderStatusBadge",
  props: ["status"],
  setup(props) {
    const { t } = useLocalization();
    return () => {
      const s = STYLE[props.status] ?? STYLE.draft;
      return (
        <span class={`badge badge-sm gap-1 whitespace-nowrap ${s.cls}`}>
          <span class="material-symbols-outlined text-[14px]">{s.icon}</span>
          {t(`inventory.orders.status_${props.status}`)}
        </span>
      );
    };
  },
});
